export const ConfirmDialogMessages = {
  NavAwayWithUnsavedChanges: {
        title: 'Unsaved data on this page',
        banner: {
          type: 'warning',
          title: 'Unsaved data will be lost.',
          description: 'Are you sure you wish to discard the changes and leave this page?'
        },
        confirmText: 'Yes, discard',
        cancelText: 'No, stay on this page',
        emphasize: 'confirm',
        disableClose: true
      },
  CancelSavedInfusion: {
        title: 'Cancel Order?',
        banner: {
          type: 'warning',
          title: 'Calibration dates for the future infusions may need to be updated.',
          description: 'If you cancel this order, the future orders (if already submitted) may require rescheduling as per the recommended interval. \n\nAre you sure you wish to cancel this order?'
        },
        confirmText: 'Yes, cancel the order',
        cancelText: 'No',
        emphasize: 'confirm',
        disableClose: true
      },
      RescheduleCalibration: {
        title: 'Rescheduling this Order?',
        banner: {
          type: 'warning',
          title: 'Calibration dates for the future infusions may need to be updated.',
          description: 'If you are rescheduling the calibration dates for this order please update the dates for any future orders as per the recommended intervals. \n\nAre you sure you wish to continue with the changes?'
        },
        confirmText: 'Yes, Continue',
        cancelText: 'No',
        emphasize: 'confirm',
        disableClose: true
      },
      DeletePhysician: {
        title: 'Confirm Delete',
        banner: {
          type: 'warning',
          title: 'Data will be deleted',
          description: 'Are you sure you wish to delete?'
        },
        confirmText: 'Yes',
        cancelText: 'No',
        emphasize: 'confirm',
        disableClose: true
      },
      ExistingOrder: {
        title: 'Existing Order',
        banner: {
          type: 'warning',
          title: 'Following order(s) exist for this patient with the same treatment plan',
          firstDescription: 'If you wish to schedule the next product on the same treatment plan please click here:',
          description: 'If you wish to start a new order with same treatment plan for the patient please click ‘Close’ and continue with the new order.'
        },
        confirmText: 'Yes',
        cancelText: 'No',
        emphasize: 'confirm',
        disableClose: false
      },
      ConfirmAlertDeletionDialogConfig: {
        title: 'Delete notification?',
        banner: {
          type: 'warning',
          title: 'You are deleting a critical alert/notification.',
          description: 'Do you want to continue?'
        },
        confirmText: 'Yes, Continue',
        cancelText: 'No',
        emphasize: 'confirm',
        disableClose: true
      }

    }
